// removed by extract-text-webpack-plugin
module.exports = {"Diet":"Diet__Diet__2z1Zr","Form":"Diet__Form__n_2Ez","Input":"Diet__Input__16rn9","Button":"Diet__Button__2-_m2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Diet/Diet.css
// module id = 109
// module chunks = 0